/* eslint-disable @typescript-eslint/no-explicit-any */
import "./antdProTablePaginationHandler.css"

export const antdProTablePaginationHandler = ({
  totalCount,
  t,
  paginationSkipCount,
  defaultPageSize = 10,
  paginationClass = "",
}: $TSMigrationFixMe) => {
  return {
    size: "default",
    total: totalCount,
    showSizeChanger: true,
    editSizeChanger: false,
    className: `tw-text-base tw-p-2 ${paginationClass}`,
    pageSizeOptions: [10, 20, 50, 100],
    hideOnSinglePage: false,
    defaultPageSize,
    locale: {
      items_per_page: " ",
      next_page: `${t("antdProTable.pagination.nextPage")}`,
      page: `${t("antdProTable.pagination.page")}`,
      prev_page: `${t("antdProTable.pagination.previousPage")}`,
      jump_to: `${t("antdProTable.pagination.jumpTo")}`,
      jump_to_confirm: `${t("antdProTable.pagination.jumpToConfirm")}`,
      next_3: `${t("antdProTable.pagination.next3")}`,
      next_5: `${t("antdProTable.pagination.next5")}`,
      prev_3: `${t("antdProTable.pagination.prev3")}`,
      prev_5: `${t("antdProTable.pagination.prev5")}`,
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    showTotal: (total: number, range: number[]) => {
      paginationSkipCount.current = range[0] - 1
      return (
        <>
          <div className='tw-inline -tw-mt-[0.2rem] -tw-ml-[12.8rem] tw-text-base'>
            {t("antdProTable.pagination.itemsPerPage")}
          </div>
          <div className='tw-inline tw-ml-[5.5rem] tw-text-base tw-text-text-50'>{`${
            range[0]
          } - ${range[1]} 
            ${t("antdProTable.pagination.of")} ${total}`}</div>
        </>
      )
    },
    editable: false,
  }
}
